import { TotalCostTooltip } from "pages/user/components";
import styled from "styled-components";
import { ButtonPrimary } from "ui/base/Button/ButtonStyled";
import { DateCard } from "ui/base/dateCard/DateCard";
import { Modal } from "ui/base/modal/Modal";
import { BlueTicket } from "ui/icons/BlueTicket";
import { themeColor } from "ui/theme";
import { USDollar } from "utils";

const getClassAmountLabel = (amount) =>
  `${amount} class${amount > 1 ? "es" : ""}`;

export const ThankYouModal = ({
  show,
  onSuccess,
  teacherName = "Teacher",
  timing = [],
  typeOfClass,
  numberOfStudents,
  lessonsCost,
  haveDiscount
}) => {

  return (
    <Modal show={show} maxWidth={450}>
      <ModalContent>
        <HeaderContentWrap>
          <BlueTicket />
          <Title>Thank you!</Title>
          <Message>We sent your request to {teacherName}'s class</Message>
        </HeaderContentWrap>
        <BodyContentWrap>
          <ClassesWrap>
            {timing.map(({ id, date, time, cost, type }) => (
              <DateCard
                key={`${id}${date}`}
                date={{
                  date: date,
                  time: time,
                  cost: cost,
                  type: type,
                }}
              />
            ))}
          </ClassesWrap>
          <ClassSummary>
            <ClassDataRow>
              <span>{numberOfStudents}</span>
              <span>{getClassAmountLabel(timing.length)}</span>

              {haveDiscount ? <DiscountText>{"Total price after discount"}</DiscountText> : null}


            </ClassDataRow>
            <ClassPriceRow>
              <span>{"Total (USD)"}</span>
              <TooltipWrapper>
                <TotalCostTooltip costData={lessonsCost} />
                <span>{USDollar.format(lessonsCost.totalCost)}</span>
              </TooltipWrapper>
            </ClassPriceRow>
          </ClassSummary>
          <ButtonPrimary onClick={onSuccess}>Done</ButtonPrimary>
        </BodyContentWrap>
      </ModalContent>
    </Modal>
  );
}

const ModalContent = styled.div`
  padding-inline: 1rem;
`;

const HeaderContentWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 3rem;
`;

const Title = styled.h2`
  font-weight: 600;
  font-size: 26px;
  letter-spacing: 0%;
  text-align: center;
`;

const Message = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 155%;
  letter-spacing: 0%;
  text-align: center;
`;

const BodyContentWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 28px;
`;

const ClassesWrap = styled.div`
  display: grid;
  gap: 1rem;
`;

const ClassSummary = styled.div`
  display: grid;
  gap: 1.5rem;
`;

const ClassRow = styled.div`
  display: flex;
  justify-content: left;
  align-items: center;
  font-weight: 600;
`;

const ClassDataRow = styled(ClassRow)`
  font-size: 14px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #a7a6ce;
  justify-content: flex-start;
  gap: 1rem;
  font-size: 12px;
`;

const ClassPriceRow = styled(ClassRow)`
  font-size: 22px;
  letter-spacing: 0%;
  color: #191d3a;
`;

const TooltipWrapper = styled.span`
    display: flex;
    align-items: center;
    gap: 12px;
    margin-left: 2rem;
`;

const DiscountText = styled.p`
    color: ${themeColor('blue')};
`